import {Dispatch} from "redux";
import {RESET_CREDENTIALS, SET_CREDENTIALS} from "../action_types/credentialActionTypes";

export function setCredentials(instanceID: string, password: string) {
    return (dispatch: Dispatch) => {
        dispatch({
            instanceID,
            password,
            type: SET_CREDENTIALS,
        });
    };
}

export function resetCredentials() {
    return (dispatch: Dispatch) => {
        dispatch({
            type: RESET_CREDENTIALS,
        });
    };
}



// WEBPACK FOOTER //
// ./src/actions/credentialActions.ts